// **** import modules ****
import $ from "jquery";
import app, { vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";
// import { initArticle } from "@@components/post/dataArticle";
import Swiper, { Autoplay, EffectFade, Pagination} from 'swiper'
import "swiper/swiper-bundle.css";
Swiper.use([Autoplay, EffectFade, Pagination])

const dataKey = "slider";

// **** process ****
vuwer.add("slider", {
	selector: "#page_header"
}, function() {
	// [add child vuw]
	this
	// define [postList]
	.add("swiperWrapper", {
		vuwType: "colony",
		selector: "#swiper_wrapper",
		
		// ** for TyrellModule **
		module: {
			app,
			dataKey,
			// 取得条件
			getFilter: {
				// // 取得項目（未指定や空の配列の場合は全て取得）
				// getParams: [],
				// // 除外項目
				// kickParams: [],
				// 取得条件 ※SQLのWHEREに相当
				// conditions: [
				// 	{
				// 		targetParam: "target",
				// 		condition: "eq",	// [gt, gte, eq, lt, lte, not, in]
				// 		value: "response"
				// 	}
				// ]
				
				sort: {
					"sortKey": "dispOrder",
					"isDesc": false,
					"sortFlags": "numeric"
				}
			},
/*
			// 一覧データの日付によるグループ分けのキー（年月ごとのグループ分け）※未指定の場合は"dateUpd"
			pkGroupByDate: "dateUpd",
			
			// 一覧データの日付によるグループ分けのフォーマット ※未指定の場合は"YYYY-MM"
			byDateFormat: "YYYY-MM",
			
			// データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
			itemFilter(i, item) {
			},
*/
			
			// 設定情報の上書き
			configOverride: {
				pageLimit: 0
			}
		},
		
		// ** for VuwColony **
		// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
		articleTemplate: "",
		
		// ページャーの表示・非表示
		showPager: false,
		
		/*----------------
		* 記事表示用の関数（未指定の場合はテンプレートから生成）
		* @param item [object] １記事分のデータオブジェクト
		* @param config [object] 設定オブジェクト
		* @param $artcl [$] テンプレートから生成された$オブジェクト
		* @param module [TyrellModule] データ取得用モジュール
		* @return (falseを返すと非表示)
		*/
		// initArticle,
		
		async onReady($self) {
			if(!$self) {
				return false;
			}
			
			const { response } = await this.module.vuw._loadPromise;
			if(response.template) {
				this.setArticleTemplate(response.template);
			}
			
			await this.module.loadItems(1);
		},
		
		async onReadyLast($self) {
			if($self) {
				await this.initList(this.module.items.list);
				
				if(this.module.items?.byId) {
					Object.keys(this.module.items.byId).forEach(key => {
						const sliderItems = this.module.items.byId[key];
						const { itemId, title, link } = sliderItems;
						
						const targetElement = $self.children(`.data-record[data-id="${itemId}"]`);
						
						const $sliderImg = targetElement.find('.echoed-data[data-key="images"]').children("img");
						
						title && $sliderImg.attr("alt", title);
						link && $sliderImg.wrap($("<a/>").attr({
							"href": link,
							"target": "_blank"
						}));
					});
				}
			}
		}
	}, function() {
		// appから直接アクセス可能にする
		app[dataKey] = this.module;
	});
});
